import * as apiPostProduct from 'api/erp/PostProduct';
import * as apiGetProductMatch from 'api/match/GetMatchProductNew';
import { Functor } from 'functions/Functor';
import * as Product from 'types/Ingredient/Detail/OrderGuide/Product';
import * as ProductListErp from 'types/Recipe/Detail/ErpNew/ProductList';

export * as ProductList from 'types/Ingredient/Detail/OrderGuide/ProductList';

export type Type = Product.Type[];

export function create(): Type {
	return [];
}

export function addProduct(obj: Type, product: Product.Type): Type {
	return [...obj, product];
}

export function removeProduct(obj: Type, productId: string): Type {
	return obj.filter((p) => p.productId !== productId);
}

export const getFromApiSggestions = ProductListErp.getFromApiSggestions;

export function mapFromApiSuggestions(response: apiGetProductMatch.ResponseData): Type {
	const output = ProductListErp.mapFromApiSuggestions(response);
	return output.map((e) => ({
		...e,
		name: e.name ?? '',
		price: e.price ?? 0,
		ingredientId: e.ingredientId ?? '',
		externalUrl: e.externalUrl ?? '',
		size: e.size ? e.size.toString() : '',
		priority: e.priority ?? 0,
		selected: e.selected ?? false,
		nutrients: e.nutrients ?? {},
	}));
}

export async function getFromApi(input: apiPostProduct.Request[]): Promise<Type> {
	let output: Type = [];
	for (const i of input) {
		const response = await Functor.From(i)
			.mapAsync(apiPostProduct.callApi)
			.map((e) => e.getOrDefault({}))
			.map((e) => mapFromApi(e, i.erpName))
			.get();
		output = [...output, ...response];
	}
	return output;
}

function mapFromApi(input: apiPostProduct.ResponseData, sourceId: string): Type {
	const output: Type = [];
	for (const [productId, product] of Object.entries(input)) {
		output.push(Product.mapFromApi(product, productId, sourceId));
	}
	return output;
}

export function enrichWithIngredientId(obj: Type, ingredientId: string): Type {
	return obj.map((e) => ({ ...e, ingredientId }));
}

export function changePriority(
	obj: Type,
	input: { productId: string; sourceId: string; priority: number }
): Type {
	return obj.map((product) => {
		if (product.productId === input.productId && product.sourceId === input.sourceId) {
			return Product.setPriority(product, input.priority);
		}
		return product;
	});
}
